module.exports = __webpack_public_path__ + "static/img/50.13006475.png";